package com.macrofocus.eflux.time

import com.macrofocus.common.properties.*
import com.macrofocus.eflux.LagUnit
import com.macrofocus.eflux.toRawString
import korlibs.time.DateTime
import korlibs.time.TimeSpan

abstract class AbstractTimeTracker(date: DateTime, val history: TimeSpan? = null) : TimeTracker {
    internal val DEBUG = true

    override var reset:(() -> Unit)? = null

    override val masterDateTime: MutableProperty<DateTime> = SimpleProperty(date)
    override val displayDateTime: MutableProperty<DateTime> = SimpleProperty(date)
    override val displayDateTimeRaw: MutableProperty<String> = SimpleProperty(date.toRawString())

    override val masterLagProperty: MutableProperty<Int> = SimpleProperty(0)
    override val displayLagProperty: MutableProperty<Int> = SimpleProperty(0)
    override val lagUnitProperty: MutableProperty<LagUnit> = SimpleProperty(LagUnit.minutes)

    override val minDateTime: MutableProperty<DateTime> = SimpleProperty(masterDateTime.value)
    override val maxDateTime: MutableProperty<DateTime> = SimpleProperty(masterDateTime.value)

    override val earliestDateTime = SimpleProperty(masterDateTime.value)
    override val latestDateTime = SimpleProperty(masterDateTime.value)

    override val nowDateTime: MutableProperty<DateTime> = SimpleProperty(masterDateTime.value)
    override val liveProperty = SimpleProperty(true)
    override val newProperty = SimpleProperty(false)

    var display by PropertyDelegates.mutable(displayDateTime)
    var master by PropertyDelegates.mutable(masterDateTime)

    var masterLag by PropertyDelegates.mutable(masterLagProperty)
    var displayLag by PropertyDelegates.mutable(displayLagProperty)
    var lagUnit by PropertyDelegates.mutable(lagUnitProperty)

    var min by PropertyDelegates.mutable(minDateTime)
    var max by PropertyDelegates.mutable(maxDateTime)

    var earliest by PropertyDelegates.mutable(earliestDateTime)
    var latest by PropertyDelegates.mutable(latestDateTime)

    var now by PropertyDelegates.mutable(nowDateTime)
    var live by PropertyDelegates.mutable(liveProperty)
    var new by PropertyDelegates.mutable(newProperty)

    init {
        if(DEBUG) {
            displayDateTime.addPropertyListener(object : PropertyListener<DateTime> {
                override fun propertyChanged(event: PropertyEvent<DateTime>) {
                    println("displayDateTime: ${event.newValue.toRawString()} (was ${event.oldValue.toRawString()})")
                }
            })

            displayDateTimeRaw.addPropertyListener(object : PropertyListener<String> {
                override fun propertyChanged(event: PropertyEvent<String>) {
                    println("displayDateTimeRaw: ${event.newValue} (was ${event.oldValue})")
                }
            })

            masterDateTime.addPropertyListener(object : PropertyListener<DateTime> {
                override fun propertyChanged(event: PropertyEvent<DateTime>) {
                    println("masterDateTime: ${event.newValue.toRawString()} (was ${event.oldValue.toRawString()})")
                }
            })
        }


        masterDateTime.addPropertyListener(object : PropertyListener<DateTime> {
            override fun propertyChanged(event: PropertyEvent<DateTime>) {
                displayDateTime.value = event.newValue
            }
        })

        displayDateTime.addPropertyListener(object : PropertyListener<DateTime> {
            override fun propertyChanged(event: PropertyEvent<DateTime>) {
                displayDateTimeRaw.value = event.newValue.toRawString()
            }
        })

        masterLagProperty.addPropertyListener(object : PropertyListener<Int> {
            override fun propertyChanged(event: PropertyEvent<Int>) {
                displayLagProperty.value = event.newValue
            }
        })

        if(DEBUG) {
            minDateTime.addPropertyListener(object : PropertyListener<DateTime> {
                override fun propertyChanged(event: PropertyEvent<DateTime>) {
                    println("minDateTime: ${event.newValue.toRawString()} (was ${event.oldValue.toRawString()})")
                }
            })

            maxDateTime.addPropertyListener(object : PropertyListener<DateTime> {
                override fun propertyChanged(event: PropertyEvent<DateTime>) {
                    println("maxDateTime: ${event.newValue.toRawString()} (was ${event.oldValue.toRawString()})")
                }
            })

            earliestDateTime.addPropertyListener(object : PropertyListener<DateTime> {
                override fun propertyChanged(event: PropertyEvent<DateTime>) {
                    println("earliestDateTime: ${event.newValue.toRawString()} (was ${event.oldValue.toRawString()})")
                }
            })

            latestDateTime.addPropertyListener(object : PropertyListener<DateTime> {
                override fun propertyChanged(event: PropertyEvent<DateTime>) {
                    println("latestDateTime: ${event.newValue.toRawString()} (was ${event.oldValue.toRawString()})")
                }
            })

            displayLagProperty.addPropertyListener(object : PropertyListener<Int> {
                override fun propertyChanged(event: PropertyEvent<Int>) {
                    println("displayLag: ${event.newValue} (was ${event.oldValue})")
                }
            })

            masterLagProperty.addPropertyListener(object : PropertyListener<Int> {
                override fun propertyChanged(event: PropertyEvent<Int>) {
                    println("masterLag: ${event.newValue} (was ${event.oldValue})")
                }
            })

            liveProperty.addPropertyListener(object : PropertyListener<Boolean> {
                override fun propertyChanged(event: PropertyEvent<Boolean>) {
                    println("live: ${event.newValue} (was ${event.oldValue})")
                }
            })

            newProperty.addPropertyListener(object : PropertyListener<Boolean> {
                override fun propertyChanged(event: PropertyEvent<Boolean>) {
                    println("new: ${event.newValue} (was ${event.oldValue})")
                }
            })
        }
    }
}